import { render, staticRenderFns } from "./CatalogEducation.vue?vue&type=template&id=1b04902e&scoped=true"
import script from "./CatalogEducation.vue?vue&type=script&lang=js"
export * from "./CatalogEducation.vue?vue&type=script&lang=js"
import style0 from "./CatalogEducation.vue?vue&type=style&index=0&id=1b04902e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b04902e",
  null
  
)

export default component.exports